import { AxiosPromise } from 'axios';
import variableRegistryApi from './VariableRegistryApi';

const getVariableList = (): AxiosPromise<any> => variableRegistryApi.get('v1/variables')
const getVariableDetailsById = (id: number): AxiosPromise<any> => variableRegistryApi.get(`v1/variables/${id}`)
const updateVariableDataById = (id: number, requestPayload: any): Promise<any> => variableRegistryApi.put(`v1/variables/${id}`, requestPayload);
const createVariableData = (requestPayload: any): AxiosPromise<number> =>  variableRegistryApi.post(`v1/variables`, requestPayload);

export { getVariableList, getVariableDetailsById, updateVariableDataById, createVariableData } 
